import { createAction, props } from "@ngrx/store";
import { Ecommerce } from "src/app/models/Ecommerce";

export const setEcommerceList = createAction('[Ecommerce Store] Set Ecommerce list',
    props<{ ecommerceList: Ecommerce[]}>()
);
